import { useTranslation } from "react-i18next";
import { HELP_EMAIL, LINKS } from "utils/constants";
import GooglePlay from "components/GooglePlay/GooglePlay";
import { ReactComponent as Facebook } from "../../assets/social/facebook.svg";
import { ReactComponent as Cangaroo } from "../../assets/footer-cangaroo.svg";
import { ReactComponent as Instagram } from "../../assets/social/instagram.svg";
import { ReactComponent as SmallCangaroo } from "../../assets/small-cangaroo.svg";
import "./footer.scss";
import "./i18n";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-container">
      <Cangaroo className="cangaroo" />
      <div className="footer-content">
        <div className="footer-content-row">
          <div className="footer-content-col-sm-3 footer-content-col-11">
            <div className="follow-us-section">
              {t("footer:follow")}
              <div className="follow-us-links">
                <a href={LINKS.FB} target="_blank" rel="noreferrer">
                  <Facebook />
                </a>
                <a href={LINKS.IG} target="_blank" rel="noreferrer">
                  <Instagram />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-content-col-sm-4 footer-content-col-11">
            <div className="download-app-section">
              <span className="download-label">{t("footer:download")}</span>
              <span className="download-label-mobile">
                {t("footer:downloadMobile")}
              </span>
              <GooglePlay />
            </div>
          </div>
          <div className="footer-content-col-sm-4 footer-content-col-11 last-column">
            <div className="contact-section">
              <SmallCangaroo className="small-cangaroo" />
              <p>
                {t("footer:needHelp")} <br /> {t("footer:contactUs")}
                <span className="contact-phone">{HELP_EMAIL}</span>
              </p>
            </div>
            <a className="afip-icon" href={LINKS.AFIP} target="_F960AFIPInfo">
              <img
                src="http://www.afip.gob.ar/images/f960/DATAWEB.jpg"
                alt="fiscal-data"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
